
import ShoppingCartItem  from './ShoppingCartItem'
import ShoppingCartEmpty from './ShoppingCartEmpty'
import TableList from '../TableList'

export default {
  name: 'ShoppingCartItems',
  inheritAttrs: false,
  components: {
    ShoppingCartItem,
    ShoppingCartEmpty,
    TableList
  },
  props: {
    items: {
      type: Array,
      default: null
    },
    columns: {
      type: [String, Number, Object],
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    minimal: {
      type: Boolean,
      default: false
    },
    image: {
      type: Boolean,
      default: true
    },
    breakpoint: {
      type: String,
      default: 'sm'
    }
  },
  computed: {
    listItems() {
      if (!this.items || !this.items.length) return

      const items = []

      this.items.forEach(item => {
        const newItem = { ...item, $attrs: { 'overflow': 'hidden' } }
        items.push(newItem)
      })

      return items
    }
  }
}
